import { render, staticRenderFns } from "./InspectionCriteria4.vue?vue&type=template&id=2ce33f62&scoped=true"
import script from "./InspectionCriteria4.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria4.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria4.vue?vue&type=style&index=0&id=2ce33f62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce33f62",
  null
  
)

export default component.exports